export const minifyUrl = (url: string) => {
  return url.replace(/(https?:\/\/)|(www\.)|(\/$)/g, "");
};
